module.exports = __webpack_public_path__ + "img/location-deny.bab476ff.jpg";